<template>
    <div>
        <div class="search-box">
            <p>竞赛名称：</p>
            <a-input class="input-box" />
            <p>竞赛主办方：</p>
            <a-input class="input-box" />
            <p>奖项类型：</p>
            <a-select class="input-box" allowClear>
                <a-select-option value="0">国际组织竞赛</a-select-option>
                <a-select-option value="1">国家级一等奖及以上</a-select-option>
                <a-select-option value="2">国家级二等奖</a-select-option>
                <a-select-option value="3">国家级三等奖</a-select-option>
                <a-select-option value="4">国家级参赛奖优胜</a-select-option>
                <a-select-option value="5">国家级未获奖</a-select-option>
            </a-select>
            <a-button type="primary" icon="search">搜索</a-button>
            <a-button type="primary" icon="download" class="right-btn" >导出Excel</a-button>
            <a-button type="primary" icon="plus" class="right-btn" @click="$router.push('/admin/undergraduate/student/subject/info?type=add')">新增</a-button>
        </div>
        <a-table 
            :columns="columns" 
            :data-source="data" 
            :loading="loading"
            :pagination="pagination"
            @change="handleTableChange"
            bordered>
            <template slot="id" slot-scope="text">
                <a class="action-btn" @click="$router.push('/admin/undergraduate/student/subject/info?type=look&id='+text)">详情</a>
                <a-divider type="vertical" />
                <a class="action-btn" @click="$router.push('/admin/undergraduate/student/subject/info?type=update&id='+text)">编辑</a>
                <a-divider type="vertical" />
                <a class="action-btn">删除</a>
            </template>
        </a-table>
    </div>
</template>
<script>
    const columns = [
        {
            title: '系别',
            dataIndex: 'v1',
            align:'center'
        },
        {
            title: '姓名',
            dataIndex: 'v2',
            align:'center'
        },
        {
            title: '类别',
            dataIndex: 'v3',
            align:'center'
        },
        {
            title: '人数',
            dataIndex: 'v4',
            align:'center'
        },
        {
            title: '竞赛项目/组别',
            dataIndex: 'v5',
            align:'center'
        },
        {
            title: '指导教师/工号',
            dataIndex: 'v6',
            align:'center'
        },
        {
            title: '奖项名称',
            dataIndex: 'v7',
            align:'center'
        },
        {
            title: '获奖等级',
            dataIndex: 'v8',
            align:'center'
        },
        {
            title: '奖项类型',
            dataIndex: 'v9',
            align:'center'
        },
        {
          title: '操作',
          dataIndex: 'id',
          scopedSlots: { customRender: 'id' }
        }

    ];
    export default {
        name: 'teacher',
        components: {
        },
        data () {
            return {
                columns,
                data:[],
                loading: false,
                pagination:{
                    pageSize: 10,
                    current: 0,
                    total:0,
                }
            }
        },
        mounted () {
            this.fetch()
        },
        methods:{
            handleTableChange(pagination){
                const pager = { ...this.pagination };
                pager.current = pagination.current;
                this.pagination = pager;
                this.fetch();
            },
            fetch() {
                this.loading = true;
                this.pagination.current = 1;
                this.pagination.total = 10;
                this.data = [];
                for(let i=0;i<10;i++){
                    this.data.push({
                        v1:'经济学院',
                        v2:'经济学院',
                        v3:'第六届海峡两岸大学生国际经贸与商务专题竞赛大陆地区选拔赛',
                        v4:'2018.10',
                        v5:'本科生组',
                        v6:'',
                        v7:'比赛二等奖',
                        v8:'国家级二等奖',
                        v9:'团队获奖',
                    })
                }
                this.loading = false;
            },
        }
    }
</script>
<style scoped>
    .search-box
    {
        padding-bottom: 24px;
        border-bottom: 1px solid rgba(151,151,151,0.60);
        margin-bottom: 24px;
    }
    .search-box p
    {
        display: inline-block;
    }
    .search-box .right-btn
    {
        float: right;
        margin-left: 1rem;
    }
    .search-box .input-box{
        margin-right: 1rem;
        width: 13rem;
    }
    .ant-table-wrapper >>> .ant-table-thead > tr > th,
    .ant-table-wrapper >>> .ant-table-tbody > tr > td{
        padding: 14px;
    }
    .action-btn{
        color: #40a9ff;
        display: inline-block;
    }
</style>
